var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchbyservicenumber(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search_by_service_number",
    "data-name": "search by service number",
    transform: "translate(-510 -293)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    width: 72,
    height: 72,
    rx: 12,
    transform: "translate(510 293)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "search_byservice_number_icon",
    "data-name": "search byservice number icon",
    transform: "translate(522 305)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_51",
    "data-name": "Rectangle 51",
    width: 48,
    height: 48,
    transform: "translate(0)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_342",
    "data-name": "Group 342",
    transform: "translate(2.625 13.334)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_9",
    "data-name": "Subtraction 9",
    d: "M31.607,13.944H9.852c.025-.224.04-.458.044-.7a7.6,7.6,0,0,0-.027-.8H31.607a1.514,1.514,0,0,0,1.53-1.494V2.988a1.514,1.514,0,0,0-1.53-1.494H3.059a1.514,1.514,0,0,0-1.53,1.494V5.607A7.541,7.541,0,0,0,0,5.935V2.988A3.027,3.027,0,0,1,3.059,0H31.607a3.028,3.028,0,0,1,3.059,2.988v7.968A3.028,3.028,0,0,1,31.607,13.944Z",
    transform: "translate(6.709 0)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_396",
    "data-name": "Group 396",
    transform: "matrix(0.875, -0.485, 0.485, 0.875, 0, 10.856)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    d: "M6.554,1.494a5.06,5.06,0,1,0,5.06,5.06,5.066,5.066,0,0,0-5.06-5.06M6.554,0A6.554,6.554,0,1,1,0,6.554,6.554,6.554,0,0,1,6.554,0Z",
    transform: "matrix(1, 0.017, -0.017, 1, 0.229, 0)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_29",
    "data-name": "Line 29",
    d: "M.747,6.474A.747.747,0,0,1,0,5.727V.747a.747.747,0,0,1,1.494,0v4.98A.747.747,0,0,1,.747,6.474Z",
    transform: "matrix(1, 0.017, -0.017, 1, 5.903, 12.302)",
    fill: "#006"
  })), /*#__PURE__*/React.createElement("text", {
    id: "T025",
    transform: "translate(17.524 8.962)",
    fill: "#006",
    fontSize: 5,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700,
    letterSpacing: "0.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T025")))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchbyservicenumber);
export default __webpack_public_path__ + "static/media/searchbyservicenumber.a7dffc1d82b9cee25951cc8d52f75339.svg";
export { ForwardRef as ReactComponent };